import moment from 'moment';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Constants } from '@config/constants';
import { HttpClient } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import {
  IMachineTotals,
  IMachineTotalJobs,
  IMachineJobsByLabelFilter,
} from 'app/models';
import { ErrorHandlingService } from '../error-handling/error.handling.service';

@Injectable()
export class DataWorkByLabelService {
  constructor(
    private readonly http: HttpClient,
    private readonly constants: Constants,
    private readonly errorHandlingService: ErrorHandlingService
  ) {}

  downloadDataWorkCSVByLabel = (queryParams: string): any =>
    this.http
      .get(
        `${this.constants.DATAWORKS_CSV_BY_LABEL_ENDPOINT}?${queryParams}`,
        {responseType: 'blob'}
      );

  getTotalJobsByLabel = ({
    customerId,
    dateRange: { startDate, endDate } = {
      startDate: moment().startOf('day'),
      endDate: moment().endOf('day'),
    },
    labelType,
    labelCode,
  }: IMachineJobsByLabelFilter): Observable<IMachineTotalJobs[]> =>
    this.http
      .get<IMachineTotalJobs[]>(
          this.constants.DATAWORKS_BY_LABEL_ENDPOINT
        + `?customerId=${customerId}`
        + `&from=${moment(startDate).format('YYYY-MM-DDTHH:mm:ss')}`
        + `&to=${moment(endDate).format('YYYY-MM-DDTHH:mm:ss')}`
        + `&labelType=${labelType}`
        + `&labelCode=${labelCode}`
      )
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );


  getTotalsByLabel = ({
    customerId,
    dateRange: { startDate, endDate } = {
      startDate: moment().startOf('day'),
      endDate: moment().endOf('day'),
    },
    labelType,
    labelCode,
  }: IMachineJobsByLabelFilter): Observable<IMachineTotals> =>
    this.http
      .get<IMachineTotals>(
        this.constants.DATAWORKS_TOTALS_BY_LABEL_ENDPOINT
        + `?customerId=${customerId}`
        + `&from=${moment(startDate).format('YYYY-MM-DDTHH:mm:ss')}`
        + `&to=${moment(endDate).format('YYYY-MM-DDTHH:mm:ss')}`
        + `&labelType=${labelType}`
        + `&labelCode=${labelCode}`
      )
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );
}
